module.exports = __webpack_public_path__ + "static/media/daohaus__logo--white.0b05ac54.png";